"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Disposal32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M26.743 9.494a.468.468 0 01.64.166c3.456 5.987 1.331 13.707-4.736 17.21a12.69 12.69 0 01-11.62.579l1.261 2.185a.468.468 0 01-.175.637.468.468 0 01-.64-.167l-1.857-3.217a.468.468 0 01.175-.637l3.26-1.882a.468.468 0 01.64.167.468.468 0 01-.175.637l-2.312 1.335a11.75 11.75 0 0010.979-.442c5.618-3.243 7.585-10.39 4.385-15.934a.468.468 0 01.175-.637zM20.538.746a.468.468 0 01.64.166l1.857 3.217a.468.468 0 01-.176.638L19.6 6.649a.468.468 0 01-.64-.167.468.468 0 01.176-.637l2.311-1.335a11.75 11.75 0 00-10.978.441C4.85 8.195 2.883 15.343 6.083 20.886a.468.468 0 01-.175.637.468.468 0 01-.64-.167C1.812 15.37 3.936 7.65 10.004 4.147a12.69 12.69 0 0111.62-.579l-1.262-2.185a.468.468 0 01.176-.637z", className: "disposal-32_svg__path-1" }))); };
var StyledDisposal32 = styled_components_1.default(Disposal32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledDisposal32;
var templateObject_1;
//# sourceMappingURL=Disposal32.js.map